import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=c46be390&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=c46be390&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46be390",
  null
  
)

export default component.exports